import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import gql from 'graphql-tag';
import { SplitButton } from 'primereact/splitbutton';

import { withAccount } from '../AccountContext';
import {
  growlErrors, growlActionSuccess,
} from '../../utils/NotificationUtil';
import { AssessmentConstants } from '../../shared/Constants';
import { sendInvitation } from '../../services/apps/AssessmentServices';
import { intlShape, growlShape } from '../prop-types';
import { withGrowl } from '../GrowlNotifications';

const SEND_ASMT_INVITE_MUTATE = gql`
  mutation($input: InviteRespondentTakeAssessmentInput!) {
    invitation: inviteRespondentTakeAssessment(input: $input) {
      assessment {
        id
        status
        startedOn
        submittedOn
        createdOn
        updatedOn
        invitedOn
        remindedOn
        expiredOn
      }
    }
  }
`;

const SEND_SURVEY_INVITE_MUTATE = gql`
  mutation($input: InviteRespondentTakeSurveyInput!) {
    invitation: inviteRespondentTakeSurvey(input: $input) {
      assessment: surveyRespondent {
        id
        status
        startedOn
        submittedOn
        createdOn
        updatedOn
        invitedOn
        remindedOn
        expiredOn
      }
    }
  }
`;

const SEND_JPS_MUTATE = gql`
  mutation($input: InviteRespondentTakeJPSAssessmentInput!) {
    invitation: inviteRespondentTakeJPSAssessment(input: $input) {
      assessment: jobProfileSurvey {
        id
        status
        startedOn
        submittedOn
        createdOn
        updatedOn
        invitedOn
        remindedOn
        expiredOn
      }
    }
  }
`;

const getMutateAndInput = (asmt, account) => {
  switch (asmt.instrument) {
    case AssessmentConstants.INSTRUMENT_TYPES.C360: {
      return {
        mutation: SEND_SURVEY_INVITE_MUTATE,
        input: {
          surveyRespondentId: asmt.id,
          accountId: account,
        },
      };
    }
    case AssessmentConstants.INSTRUMENT_TYPES.JPS: {
      return {
        mutation: SEND_JPS_MUTATE,
        input: {
          jobProfileSurveyId: asmt.id,
          accountId: account,
        },
      };
    }
    default: {
      return {
        mutation: SEND_ASMT_INVITE_MUTATE,
        input: {
          assessmentId: asmt.id,
          accountId: account,
        },
      };
    }
  }
};

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  invite: {
    id: 'assessment.invite.send',
    defaultMessage: 'Send Invite',
  },
  previewInvite: { id: 'assessment.invite.preview', defaultMessage: 'Preview Invite' },
  previewReminder: { id: 'assessment.remind.preview', defaultMessage: 'Preview Reminder' },
});

class BoxActionInvite extends Component {
  constructor(props) {
    super(props);
    this.handleSendInvite = this.handleSendInvite.bind(this);
    this.timelineContextMenu = this.timelineContextMenu.bind(this);
  }

  async handleSendInvite(event) {
    event.preventDefault();
    const {
      updateLastAction, growl,
      intl, assessment, currentAccount,
    } = this.props;
    const { formatMessage } = intl;
    const { mutation, input } = getMutateAndInput(assessment, currentAccount);
    try {
      const result = await sendInvitation({ mutation, input });
      const { status } = result.invitation.assessment;
      updateLastAction(status);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  timelineContextMenu() {
    const {
      intl: { formatMessage },
      assessment,
    } = this.props;
    const items = [
      {
        label: formatMessage(messages.previewInvite),
        command: () => {
          window.open(assessment.previewInviteUrl, '_blank');
        },
      },
      {
        label: formatMessage(messages.previewReminder),
        command: () => {
          window.open(assessment.previewReminderUrl, '_blank');
        },
      },
    ];

    return items;
  }

  render() {
    const { assessment, intl } = this.props;
    const { formatMessage } = intl;
    const titleText = formatMessage(messages.invite);
    return (
      <div className="vertList-item vertList-item--block">
        <FormattedMessage id="assessment.invite" defaultMessage="Invite Candidate">
          {text => <p className="vertList-header">{text}</p>}
        </FormattedMessage>

        <div className="vertList-actions">
          <SplitButton
            id={assessment.id}
            label={titleText}
            icon="fa fa-envelope-o"
            model={this.timelineContextMenu()}
            onClick={this.handleSendInvite}
          />
        </div>
      </div>
    );
  }
}

BoxActionInvite.propTypes = {
  intl: intlShape.isRequired,
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  updateLastAction: PropTypes.func.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  injectIntl(withAccount(BoxActionInvite)),
);
